import { type ComponentProps } from 'react';

const url = 'https://media.contra.com/image/upload';

type GetContraImageArgument = Pick<
  ComponentProps<'img'>,
  'height' | 'width'
> & {
  aspectRatio?: number;
  cropTransformation?: 'c_crop' | 'c_fill' | 'c_limit';
  dpr?: number;
  uid: string;
};

/**
 * Given a `uid`, returns a combined string.
 * Image can optionally be transformed using `width` and `height`
 */
export const getContraImageUrl = ({
  aspectRatio,
  cropTransformation = 'c_fill',
  dpr,
  height,
  uid,
  width,
}: GetContraImageArgument): string => {
  // f_avif - format auto automatically optimizes for the requesting browser - https://cloudinary.com/documentation/transformation_reference#f_avif
  // c_crop - crop
  const parameters = [
    'f_avif',
    cropTransformation,
    'dpr_' + (dpr ? String(dpr) : 'auto'),
    'w_' + (width ? String(width) : 'auto'),
    'fl_lossy',
    'e_loop',
    'fl_awebp',
    'fl_animated',
  ];
  // Height auto doesn't work and cloudinary returns an empty image
  // hence only add height transform if height is explicitly specified
  if (height) {
    parameters.push('h_' + String(height));
  }

  if (aspectRatio) {
    parameters.push(`ar_${aspectRatio}`);
  }

  const parametersString = parameters.join(',');

  return [url, parametersString, uid].join('/');
};
